import * as React from "react";

import { Link } from "react-router-dom";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";

import Paper from "@mui/material/Paper";
import { addCommasToNum } from "../utils";

const EventsTable = ({
  data,
  count,
  page,
  setPage,
  hoveredEventID,
  setHoveredEventID,
  selectedEventID,
  setSelectedEventID,
}) => {
  const handleChangePage = (event, newPage) => setPage(newPage);

  return (
    <TableContainer
      component={Paper}
      sx={{ width: "100%", height: "max-content" }}
    >
      <Table aria-label="events bandwidth table" size="small">
        <TableHead>
          <TableRow>
            <TableCell>Title</TableCell>
            <TableCell align="right">Live (GB)</TableCell>
            <TableCell align="right">VOD (GB)</TableCell>
            <TableCell align="right">Total (GB)</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((event) => (
            <TableRow
              key={event.eventID}
              hover
              selected={event.eventID === selectedEventID}
              data-eventid={event.eventID}
              onClick={(e) => {
                setSelectedEventID(e.currentTarget.dataset.eventid);
                setHoveredEventID(null);
              }}
              sx={{
                ...(event.eventID === hoveredEventID && {
                  backgroundColor: "#eeeeee",
                }),
                cursor: "zoom-in",
              }}
            >
              <TableCell component="th" scope="row">
                <Link to={`/events/?eventID=${event.eventID}`}>
                  {event.shortTitle}
                </Link>
              </TableCell>
              <TableCell align="right">
                {addCommasToNum(event["Live"])}
              </TableCell>
              <TableCell align="right">
                {addCommasToNum(event["Vod"])}
              </TableCell>
              <TableCell align="right">
                {addCommasToNum(event["Total Consumption"])}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              count={count}
              rowsPerPageOptions={[]}
              rowsPerPage={5}
              page={page}
              onPageChange={handleChangePage}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
};

export default EventsTable;
